import apiClient from "@/config/api";

const actions = {
    getLogs({ commit }, params = {}) {
        const config = {
            headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
            params
        }
        return new Promise((resolve, reject) => {
            apiClient.get('/audit-logs', config)
                .then(res => {
                    commit('SET_LOGS', res.data.data);
                    resolve(res.data.data);
                })
                .catch(err => {
                    reject(err);
                    console.error("API Error:", err);
                })
        })
    }
}
export default actions;
